var React = require('react');

function StepCircle0360px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-7.164-19.188c1.008.756 3.132 1.584 5.508 1.584 5.4 0 7.92-3.456 7.92-6.948 0-3.384-2.376-5.616-5.292-6.192v-.072c2.808-1.08 4.356-3.168 4.356-5.544 0-2.664-1.692-5.436-6.12-5.436-2.196 0-4.32.936-5.436 1.836l.684 1.26c1.044-.792 2.736-1.62 4.536-1.62 3.312 0 4.536 2.016 4.536 4.176 0 3.24-3.276 4.716-5.868 4.716h-1.548v1.44h1.476c3.456 0 6.84 1.584 6.876 5.508.036 2.088-1.116 5.4-5.904 5.4-2.232 0-4.212-.864-5.04-1.476l-.684 1.368z"}));
}

StepCircle0360px.displayName = "StepCircle0360px";

StepCircle0360px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0360px;

StepCircle0360px.default = StepCircle0360px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-03-60px.svg
// module id = 1208
// module chunks = 0